import deleteWithSwal from '@/common/delete_with_swal'
import setupActionCable from './action_cable'
import showFlashes from './flashes'

function initOnce() {
  deleteWithSwal()
  setupActionCable()
  showFlashes()
}

if (document.readyState !== 'loading') {
  initOnce()
} else {
  document.addEventListener('DOMContentLoaded', initOnce)
}
